module.exports = __webpack_public_path__ + "static/Voga-Medium-3254ebc400525418688b5d0a1fd0fba1.otf";